var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course_video"},[_c('div',{staticClass:"course_video-wrap"},[_c('div',{staticClass:"course_video-wrap-main w1200"},[_c('iframe',{staticClass:"course_video_iframe",attrs:{"allowfullscreen":"","src":_vm.brand_info.video_course_access_url,"frameborder":"0"}})])]),_c('div',{staticClass:"course_video-footer"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }